import React from 'react'
import photo from '../img/photo.jpg'
import reels from '../img/reels.jpg'
import shortfilm from '../img/shortfilm.jpg'
import { useNavigate } from 'react-router-dom';


const HomeEvents = () => {
      
    const history=useNavigate();
   const openExplore=(page)=>{
     history(page);
   }

    return (
        <> <h2>Events</h2>
          <div className="home__events__content">
              <div className="event1">
                <div className="img-container">
                <img src={photo} alt="photo" onClick={()=>openExplore('exploreevents5')}/>
                </div>
                  <h3>Photography contest</h3>
              </div>
              <div className="event1">
                  <div className="img-conatiner">

                  <img src={reels} alt="photo" onClick={()=>openExplore('exploreevents2')}/>
                  </div>
                  <h3>Reels contest</h3>
              </div>
              <div className="event1">
                  <img src={shortfilm} alt="photo" onClick={()=>openExplore('exploreevents3')}/>
                  <h3>ShortFilm contest</h3>
              </div>
              </div>  
        </>
    )
}

export default HomeEvents
